import { useState } from 'react';
import styles from './QuoteRequest.module.scss';
import { ReactComponent as CloseIconPressed } from '../../../assets/images/close.svg';
import Button2 from '../../Buttons/Button2/Button2';
import EmailInput from '../../Inputs/EmailInput/EmailInput';
import { post } from '../../../fetchers/fetchers';
import { ARTWORK_CONTROLLER_URL } from '../../../ressources/constants/apiRoutes';
import { useOverlay } from '../../../utils/overlays';

interface QuoteRequestProps {
  displayModal: boolean;
  hideModal: Function;
  imageURL?: string | null;
}

const QuoteRequest = (props : QuoteRequestProps) => {
  const [email, setEmail] = useState('');
  const [showEmailError, setShowEmailError] = useState(false);
  useOverlay(props.displayModal);
  
  let isInnerClick : boolean = false;

  const handleSubmit = async () => {
    setShowEmailError(true);
    
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!email || !isValidEmail) {
      return;
    }
    
    try {
      await post(ARTWORK_CONTROLLER_URL + '/saveArtwork', {
        artwork_url: props.imageURL,
        email: email
      });
      props.hideModal();
    } catch (error) {
      console.error('Failed to save artwork:', error);
    }
  };

  return props.displayModal? (
  <div onClick={() => {if(isInnerClick){isInnerClick = false}else{props.hideModal()}}} className={styles.QuoteRequest} data-testid="QuoteRequest">
    <div onClick={() => {isInnerClick = true}} className={styles.QuoteRequestContainer}>
      <div className={styles.Header}>
        <button className={styles.CloseButton} onClick={() => {props.hideModal()}}><CloseIconPressed className={styles.SVGClose}/></button>
      </div>
      <div className={styles.Content}>
        <EmailInput 
          className="EmailInput" 
          placeholder="Your email address" 
          value={email} 
          sendValue={(value: string) => {
            setEmail(value);
            setShowEmailError(false);
          }}
          showError={showEmailError}
        />
      </div>
      <div className={styles.Footer}>
        <Button2 action={handleSubmit}>Request a quote</Button2>
      </div>
    </div>
  </div> ) : null
};

export default QuoteRequest;

